<template>
<div class="finder-clinicinfo" :class="{ 's_active' : this.isActive }">
  <div class="finder-content clinicpreview">

    <div class="clinicpreview-scroll">

      <h1 class="clinicpreview-title">{{ clinic.title }}</h1>

      <p>
        <span v-if="clinic.phone"><strong>Call</strong> <a :href="`tel:${clinic.phone}`">{{ clinic.phone }}</a><br /></span>
        <span v-if="clinic.fax"><strong>Fax</strong> {{ clinic.fax }}</span>
      </p>

      <p>
        <span v-if="clinic.address1">{{ clinic.address1 }}</span><br /><nobr>{{ clinic.suburb }} {{ clinic.stateAbbrev }} {{ clinic.postcode }}</nobr><br />
      </p>

      <p>
        <strong v-html="openNow"></strong><br />
        <span v-html="openHours"></span>
      </p>

      <p v-if="clinic.services">
        <strong>Services</strong><br />
        <span v-for="(service, index) in servicesLimited">
          <span v-if="index > 0">, </span>
          <span v-html="service.title"></span></span><span v-if="servicesLimited.length < clinic.services.length">, more</span>
      </p>

      <!-- <ul class="clinicpreview-services">
        <li><strong>Services</strong></li>
        <li v-for="service in servicesLimited" v-html="service.title"></li>
      </ul> -->

      <a :href=clinic.url class="btn l_thick l_white">More information</a>

    </div>

    <button @click="closeBox" class="clinicpreview-return">
      <svg class="icon"><use href="#chevron-left"></use></svg>
      Return to all results
    </button>

  </div>
</div>
</template>

<script>
import getDistance from 'geolib/es/getDistance';
import EventBus from '../utils/event-bus';
import * as openHours from '../utils/open-hours';
export default {
  name: "ClinicInfo",
  data() {
    return {

      clinic: false,
      isActive: false

    };
  },
  props: {
    searchId: String
  },
  computed: {

    openNow() {
      // return false;
      return openHours.displaySimple(this.clinic);
    },

    openHours() {
      // return '';
      return openHours.outlook(this.clinic);
    },

    servicesLimited() {
      if (typeof this.clinic.services !== 'undefined') {
        return this.clinic.services.slice(0, 6);
      }
      return false;
    }

  },
  methods: {

    closeBox() {

      this.isActive = false;
      EventBus.$emit('CLINIC_HIDE', this.searchId);

    },

  },
  mounted() {

    EventBus.$on('CLINIC_DISPLAY', (searchId, clinic) => {
      this.clinic = clinic;
      this.isActive = true;
    });

  },
};
</script>

<style scoped>
</style>